import React, { useState } from "react";
import { Table } from "reactstrap";
import style from "./DocumentTable.scss";
import downloadSvg from "../../../public/svg/download-svgrepo-com.svg";
import pdfSvg from "../../../public/svg/pdf.svg";

export const DocumentTable = ({ docType, date, download, pdf }) => {
  return (
    <Table className={style.table}>
      <tbody className={style.tbody}>
        <tr>
          <td>{docType}</td>
          <td>{date}</td>
          <td>{pdf ? <img src={pdfSvg} className={style.icon} alt="pdf"/> : null}</td>
          <td>{download ? <img src={downloadSvg} className={style.icon} alt="download"/> : null}</td>
        </tr>
      </tbody>
    </Table>
  );
};
